export const WORLD_WIDTH = 3600;
export const PLAYER_SIZE = 64;
export const CHECKPOINTS = [
  ['about', 'Origin story', 'Meet the builder', '01'],
  ['education', 'Learning grounds', 'Purdue & beyond', '02'],
  ['experience', 'The proving grounds', 'Systems in production', '03'],
  ['projects', 'Idea factory', 'Explore what shipped', '04'],
  ['skills', 'Power-up station', 'Tools of the trade', '05'],
  ['certifications', 'Trophy room', 'CSPO & achievements', '06'],
  ['contact', 'The next adventure', 'Build something together', '07']
].map(([id,label,description,number],i)=>({id,label,description,number,x:300+i*430,y:155}));
export const END_PIPE = {id:'personal-warp',x:3420,width:96,height:112,warp:true};
export const PIPES = [
  ...CHECKPOINTS.map(c=>({id:`pipe-${c.id}`,x:c.x+210,width:76,height:96})),
  END_PIPE
];
export const COINS = Array.from({length:24},(_,i)=>({id:i,x:170+i*125,y:60+(i%3===1?45:0)}));
export const initialPlayer=()=>({x:60,y:0,vx:0,vy:0,facing:1});
const POSITION_EPSILON = 0.01;
const overlapsPipe = (player,pipe)=>player.x+PLAYER_SIZE>pipe.x && player.x<pipe.x+pipe.width;
const isStandingOn = (player,pipe)=>Math.abs(player.y-pipe.height)<POSITION_EPSILON && Math.abs(player.vy)<0.5 && overlapsPipe(player,pipe);
export function isGrounded(player){
  return (Math.abs(player.y)<POSITION_EPSILON && Math.abs(player.vy)<0.5) || PIPES.some(pipe=>isStandingOn(player,pipe));
}
export function canEnterPipe(player){
  const center=player.x+PLAYER_SIZE/2;
  return isStandingOn(player,END_PIPE) && center>=END_PIPE.x+8 && center<=END_PIPE.x+END_PIPE.width-8;
}
export function stepPlayer(player,input,dt,unlocked=new Set(),collected=new Set()) {
  const next={...player};
  const direction=Number(!!input.right)-Number(!!input.left);
  const target=direction*300;
  if(direction)next.facing=direction;
  // Small physics steps keep thin ledges solid even after a delayed frame.
  const duration=Number.isFinite(dt)?Math.max(0,dt):0;
  const steps=Math.max(1,Math.ceil(duration/(1/120)));
  const delta=duration/steps;
  let hit=null;
  const coins=new Set();
  for(let step=0;step<steps;step++){
    const previous={...next};
    const acceleration=1800*delta;
    next.vx+=Math.max(-acceleration,Math.min(acceleration,target-next.vx));
    if(step===0 && input.jump && isGrounded(next))next.vy=650;
    next.vy-=1500*delta;
    let destinationX=Math.max(0,Math.min(WORLD_WIDTH-PLAYER_SIZE,next.x+next.vx*delta));
    for(const pipe of PIPES){
      if(previous.y>=pipe.height-POSITION_EPSILON)continue;
      if(previous.x+PLAYER_SIZE<=pipe.x+POSITION_EPSILON && destinationX+PLAYER_SIZE>pipe.x){
        destinationX=Math.min(destinationX,pipe.x-PLAYER_SIZE);
        next.vx=0;
      }else if(previous.x>=pipe.x+pipe.width-POSITION_EPSILON && destinationX<pipe.x+pipe.width){
        destinationX=Math.max(destinationX,pipe.x+pipe.width);
        next.vx=0;
      }
    }
    next.x=destinationX;
    next.y=Math.max(0,next.y+next.vy*delta);
    if(next.vy<=0){
      for(const pipe of PIPES){
        if(previous.y>=pipe.height-POSITION_EPSILON && next.y<=pipe.height && overlapsPipe(next,pipe)){
          next.y=pipe.height;
          next.vy=0;
        }
      }
    }
    for(const box of CHECKPOINTS){
      if(next.vy>0 && previous.y+PLAYER_SIZE<=box.y && next.y+PLAYER_SIZE>=box.y && next.x+PLAYER_SIZE>box.x && next.x<box.x+64){
        hit=hit || box.id;next.y=box.y-PLAYER_SIZE;next.vy=-100;break;
      }
    }
    if(next.y===0)next.vy=0;
    for(const coin of COINS){
      if(!collected.has(coin.id) && Math.abs(coin.x-(next.x+PLAYER_SIZE/2))<40 && coin.y>next.y-10 && coin.y<next.y+PLAYER_SIZE+10)coins.add(coin.id);
    }
  }
  return {player:next,hit,coins:[...coins]};
}
export function readProgress(storage){
  try {
    const saved=JSON.parse(storage.getItem('uj-arcade-v2'));
    return {unlocked:new Set((Array.isArray(saved?.unlocked)?saved.unlocked:[]).filter(id=>CHECKPOINTS.some(c=>c.id===id))),coins:new Set((Array.isArray(saved?.coins)?saved.coins:[]).filter(id=>Number.isInteger(id)&&id>=0&&id<COINS.length))};
  }catch{return {unlocked:new Set(),coins:new Set()};}
}
